import React from 'react';
import CompanyCard from './CompanyCard';

import { Button, CloseButton, Dialog, Heading, Image, Flex, Link, Center, Portal } from "@chakra-ui/react"
import { FaArrowRightLong } from "react-icons/fa6";

import './styles/NegotiatedCompaniesBanner.css';

function NegotiatedCompaniesBanner() {

    let companies = [
        'meta',
        'amazon',
        'google',
        'citadel',
        'doordash',
    ];

    let companyHeights = [
        '24px',
        '32px',
        '28px',
        '20px',
        '24px',
    ]

    let companyWidths = [
        '150px',
        '125px',
        '115px',
        '175px',
        '200px',
    ]

    function renderDesktopCompanyCards(){
        let cards = [];
        for (var i = 0; i < companies.length; i++) {
            cards.push(
                <Image 
                    height={companyHeights[i]}
                    src={'/assets/images/' + companies[i] + '_logo.png'}
                />
                
                // <CompanyCard 
                //     height={companyHeights[i]}
                //     src={'/assets/images/' + companies[i] + '_logo.png'} key={companies[i]}/>
            )
        }

        return cards;
    }

    function renderMobileCompanyCards(){
        let cards = [];
        for (var i = 0; i < companies.length; i++) {
            cards.push(
                <Center style={{marginTop: '20px'}}>
                    <Image 
                        width={companyWidths[i]}
                        src={'/assets/images/' + companies[i] + '_logo.png'}
                    />
                </Center>
            )
        }

        return cards;
    }

    return (
        <div>
            {/* Desktop only view */}
            <Flex 
                className="negotiated_companies_banner__parent"
                direction='column'
                gap='12'
            >
                <Heading color='black' fontWeight='bold' size='4xl'
                >
                    Companies we've negotiated offers for
                </Heading>
                <Flex 
                    gap='24'
                    justify='center'
                    style={{marginTop: '50px'}}
                >
                    {renderDesktopCompanyCards()}
                </Flex>
                <Center style={{marginTop: '40px'}}>
                    <Dialog.Root size='md'>
                        <Dialog.Trigger asChild>
                            <Link color='black' variant='underline'>
                                See the full list <FaArrowRightLong />
                            </Link>
                        </Dialog.Trigger>
                        <Portal>
                            <Dialog.Backdrop />
                            <Dialog.Positioner>
                                <Dialog.Content>
                                <Dialog.Header color='black'>
                                    <Dialog.Title>Companies</Dialog.Title>
                                </Dialog.Header>
                                <Dialog.Body>
                                    <Flex gap='14'>
                                        <Flex direction='column' gap='2'>
                                            <Flex color='gray' fontWeight='bold'>
                                                Amazon
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Apple
                                            </Flex> 
                                            <Flex color='gray' fontWeight='bold'>
                                                Cardless
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Citadel
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Cruise
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Doordash
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Google
                                            </Flex>
                                        </Flex>
                                        <Flex direction='column' gap='2'>
                                            <Flex color='gray' fontWeight='bold'>
                                                Intuit
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Lattice
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Meta
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Pinwheel
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Plaid
                                            </Flex>   
                                            <Flex color='gray' fontWeight='bold'>
                                                Toast
                                            </Flex>   
                                            <Flex color='gray' fontWeight='bold'>
                                                Thumbtack
                                            </Flex>    
                                        </Flex>
                                        <Flex direction='column' gap='2'>
                                            <Flex color='gray' fontWeight='bold'>
                                                TikTok
                                            </Flex>    
                                            <Flex color='gray' fontWeight='bold'>
                                                Uber
                                            </Flex>    
                                            <Flex color='gray' fontWeight='bold'>
                                                Intuit
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Lattice
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Meta
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Pinwheel
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Plaid
                                            </Flex>   
                                        </Flex>
                                        <Flex direction='column' gap='2'>
                                            <Flex color='gray' fontWeight='bold'>
                                                Toast
                                            </Flex>   
                                            <Flex color='gray' fontWeight='bold'>
                                                Thumbtack
                                            </Flex>    
                                            <Flex color='gray' fontWeight='bold'>
                                                TikTok
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Uber
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                </Dialog.Body>
                                <Dialog.CloseTrigger asChild>
                                    <CloseButton size="sm" />
                                </Dialog.CloseTrigger>
                                </Dialog.Content>
                            </Dialog.Positioner>
                        </Portal>
                    </Dialog.Root>
                </Center>
            </Flex>

            {/* Mobile only view */}
            <Flex 
                className="negotiated_companies_banner__mobile_parent"
                direction='column'
                gap='12'
            >
                <Heading color='black' fontWeight='bold' size='3xl'
                >
                    Companies we've negotiated offers for
                </Heading>
                <Flex 
                    direction='column'
                    gap='6'
                    justify='center'
                    style={{marginTop: '10px'}}
                >
                    {renderMobileCompanyCards()}
                </Flex>
                <Center style={{marginTop: '35px'}}>
                    <Dialog.Root size='xs'>
                        <Dialog.Trigger asChild>
                            <Link color='black' variant='underline'>
                                See the full list <FaArrowRightLong />
                            </Link>
                        </Dialog.Trigger>
                        <Portal>
                            <Dialog.Backdrop />
                            <Dialog.Positioner>
                                <Dialog.Content>
                                <Dialog.Header color='black'>
                                    <Dialog.Title>Companies</Dialog.Title>
                                </Dialog.Header>
                                <Dialog.Body>
                                    <Flex gap='8'>
                                        <Flex direction='column' gap='2'>
                                            <Flex color='gray' fontWeight='bold'>
                                                Amazon
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Apple
                                            </Flex> 
                                            <Flex color='gray' fontWeight='bold'>
                                                Cardless
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Citadel
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Cruise
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Doordash
                                            </Flex>
                                            
                                        </Flex>
                                        <Flex direction='column' gap='2'>
                                            <Flex color='gray' fontWeight='bold'>
                                                Google
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Intuit
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Lattice
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Meta
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Pinwheel
                                            </Flex>
                                            <Flex color='gray' fontWeight='bold'>
                                                Plaid
                                            </Flex>   
                                        </Flex>
                                        <Flex direction='column' gap='2'>
                                            <Flex color='gray' fontWeight='bold'>
                                                Toast
                                            </Flex>   
                                            <Flex color='gray' fontWeight='bold'>
                                                Thumbtack
                                            </Flex> 
                                            <Flex color='gray' fontWeight='bold'>
                                                TikTok
                                            </Flex>    
                                            <Flex color='gray' fontWeight='bold'>
                                                Uber
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                </Dialog.Body>
                                <Dialog.CloseTrigger asChild>
                                    <CloseButton size="sm" />
                                </Dialog.CloseTrigger>
                                </Dialog.Content>
                            </Dialog.Positioner>
                        </Portal>
                    </Dialog.Root>
                </Center>
            </Flex>
        </div>
    );
}

export default NegotiatedCompaniesBanner;
